 <nb-card *ngIf="stream"  style="margin-bottom: 0rem !important;"  class="own-scroll">     
                            <nb-card-header>
				<div style="display:flex">
                              <div  style="display:flex;   cursor:pointer;  margin-top: auto;
    margin-bottom: auto;"  ><span style="display:flex"><span class="iconTop subtitleControlIcon" aria-hidden="true"></span></span> <span> Субтiтри</span></div>  
<div  style="display:flex; margin-left:auto; cursor:pointer;  margin-top: auto;
    margin-bottom: auto;">
	 
				   <nb-toggle  
 
				      [(checked)]="isEnabled" 
				      (checkedChange)="toggleEnabled()" 
				     labelPosition="left" 
				      status="primary">
				      
				      <span *ngIf="isEnabled">Увімкнено</span>
				      <span *ngIf="!isEnabled">Вимкнено</span>
				    </nb-toggle>

   </div>
				</div>
                            </nb-card-header>
                            <nb-card-body  *ngIf="isEnabled" >
                            
                            
                            <div class="items"> 
                            
                            	<div *ngFor="let item of items; let i = index" class="item d-flex">
                            	
                            	
                            		<div class="d-flex bg subtitlesControlBg">
                            	
		                    		<div class="">
		                    		  <span class="d-flex" style="    align-items: center;"> 
		                    		        <span><span class="icon subtitleControlIcon" aria-hidden="true"></span></span>
		                    		         <span class="fw-bold">Мова {{i+1}}</span>  
		                    		   </span> 
		                    		</div>
		                    		
		                    		<div  class="">
		                    		<span>Назва мови при виборі <br/> в плеєрі. Наприклад EN</span>
		                    		</div>
		                    		
		                    		<div class="">
		                    		<input nbInput [value]="item.title || ''" (change)="titleChanged(item.identity, $event)" class="title-input" />
		                    		</div>
		                    		
		                    		<div class="">
		                    		   <span><span class="fw-bold">Файл субтитрів.</span> <br/> Файл <span class="fw-bold"> *.SRT</span> </span>
		                    		</div>
		                    		
		                    		<div  class="d-flex" style="flex:1">
		                    			<div *ngIf="!item.file" (click)="setUploadIdentity(item.identity); uploadSubtitle.click();" class="button fileUpload">
		                    				<span>Вибрати файл</span>
		                    			</div>
		                    		
		                    			
		                    			<div  *ngIf="item.file" (click)="removeFile(item.identity)" class="button fileDelete">
		                    				<span>Видалити файл</span>
		                    			</div>
		                    		</div>
                            		</div>
                            		 
                            		 <div class="remove">
                            		       <span (click)="deleteItem(item.identity)" ><i class="fa fa-times" aria-hidden="true"></i></span>
                            		 </div>
                            	 
                            	</div>
                            
                            
                            </div>
                            <div style="margin-top:20px;" class=" d-flex">
                            		 
                            		<input type="file" (change)="uploadFile($event.target )" #uploadSubtitle style="display:none" />
                            		 
                            		<div class="d-flex" style="margin:auto">
                            		<button nbButton status="primary"  (click)="addItem()" >Додати мову</button>
                            		</div>
                            </div>
                            
 	 
                            </nb-card-body>
                            
                            </nb-card>
 
  


 
